var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"canvas bg-white",class:{
    unlimited: !_vm.limitPresets,
  },style:({
    '--primary-color': _vm.settings.primaryColor,
    '--secondary-color': _vm.settings.secondaryColor,
    '--promo-color': _vm.settings.promotionColor,
    '--font-heading': _vm.headingFont,
    '--font-body': _vm.bodyFont,
  })},[(_vm.scopedCss)?_c('style',{tag:"component"},[_vm._v(" "+_vm._s(_vm.scopedCss)+" ")]):_vm._e(),_c('div',{ref:"container",staticClass:"modulos-wrapper canvas__page"},_vm._l((_vm.instanceList),function(instanceId){return _c('EditableInstance',{key:instanceId,attrs:{"instance-id":instanceId}})}),1),_c('AddComponent',{directives:[{name:"show",rawName:"v-show",value:(!_vm.limitPresets),expression:"!limitPresets"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }